import { Component, Input, OnInit, Output, EventEmitter, HostListener } from '@angular/core';
import { HeaderService } from '../../tools/header.service';
import { Sort } from '@angular/material/sort';
import { SearchCrit } from 'src/app/entities/searchCrit';
import { Reference } from '../../tools/api.service';

@Component({
    selector: 'multiTon',
    templateUrl: './multiTon.component.html',
    styleUrls: ['./multiTon.component.scss']
})

export class MultiTonComponent implements OnInit {
    @Input() biTons: Reference[];
    @Input() searchCrit: SearchCrit;
    @Output() reference = new EventEmitter<Reference>();

    displayedColumns = ["manufacturer", "code", "designation", "dateFrom", "dateTo", "numformula", "numshader", "technology", "ssCouche"];

    sortedResults: Reference[];
    private logo: any;
    private title: any;

    constructor(private headerService: HeaderService) { }

    @HostListener('window:popstate', ['$event'])
    onPopState(event: any) {
        this.headerService.changeBack(true);
    }

    ngOnInit(): void {

        //console.log(this.biTons);

        window.onpopstate = function () {
        };

        if (this.searchCrit.searchWorld)
            this.displayedColumns.push("region");

        this.sortedResults = this.biTons.slice();
    }

    SelectReference(ref: Reference) {
        this.reference.emit(ref);
    }

    sortReferences(sort: Sort) {
        const isAsc = sort.direction == 'asc';
        const data = this.sortedResults.slice();
        if (!sort.active || sort.direction === '') {
            this.sortedResults = data;
            return;
        }

        this.sortedResults = data.sort((a, b) => {
            switch (sort.active) {
                case "manufacturer":
                    if (a.manufacturer == b.manufacturer) return 0;
                    return (a.manufacturer < b.manufacturer ? -1 : 1) * (isAsc ? 1 : -1);
                case "code":
                    if (a.code == b.code) return 0;
                    return (a.code < b.code ? -1 : 1) * (isAsc ? 1 : -1);
                case "designation":
                    if (a.designation == b.designation) return 0;
                    return (a.designation < b.designation ? -1 : 1) * (isAsc ? 1 : -1);
                case "dateFrom":
                    if (a.dateFrom == b.dateFrom) return 0;
                    return (a.dateFrom < b.dateFrom ? -1 : 1) * (isAsc ? 1 : -1);
                case "dateTo":
                    if (a.dateTo == b.dateTo) return 0;
                    return (a.dateTo < b.dateTo ? -1 : 1) * (isAsc ? 1 : -1);
                case "numformula":
                    if (a.formuleNum == b.formuleNum) return 0;
                    return (a.formuleNum < b.formuleNum ? -1 : 1) * (isAsc ? 1 : -1);
                case "numshader":
                    if (a.shadeGuideNum == b.shadeGuideNum) return 0;
                    return (a.shadeGuideNum < b.shadeGuideNum ? -1 : 1) * (isAsc ? 1 : -1);
                case "technology":
                    if (a.technology == b.technology) return 0;
                    return (a.technology < b.technology ? -1 : 1) * (isAsc ? 1 : -1);
                case "ssCouche":
                    if (a.ssCouche == b.ssCouche) return 0;
                    return (a.ssCouche < b.ssCouche ? -1 : 1) * (isAsc ? 1 : -1);
                case "region":
                    if (a.region == b.region) return 0;
                    return (a.region < b.region ? -1 : 1) * (isAsc ? 1 : -1);
            }
        })
    }
}
